import type { HandleClientError } from '@sveltejs/kit';
import { initTelemetry, reportError } from '$lib/telemetry/telemetry';

initTelemetry();

export const handleError: HandleClientError = ({ error }) => {
	reportError(error);
};
